import { useEffect, useState } from "react"
import { ColorResult, RGBColor, SketchPicker } from "react-color"
import { translations } from "../../../../configs/translations"
import { Language } from "../../../../context/LanguageContext"
import './ColorBlock.css'

export interface ColorBlockProps {
    color?: RGBColor
    setColor?: (color: RGBColor) => void
}

export const ColorBlock = (props: ColorBlockProps) => {
    const [language, setLanguage] = useState<Language>('ru')
    const t = translations[language]

    const handleChange = (newColor: ColorResult) => {
        if (props.setColor) {
            props.setColor(newColor.rgb)
        }
    }

    const getColorInput = (input: string): number => {
        if (isNaN(parseInt(input)) || parseInt(input) < 0) {
            return 0
        } else if (parseInt(input) > 255) {
            return 255
        } else {
            return parseInt(input)
        }
    }

    const [hexInput, setHexInput] = useState("#ff0000")

    useEffect(() => {
        if (!props.color) return
        const r = props.color.r.toString(16).padStart(2, "0")
        const g = props.color.g.toString(16).padStart(2, "0")
        const b = props.color.b.toString(16).padStart(2, "0")
        const newHex = `#${r}${g}${b}`
        if (newHex.toLowerCase() !== hexInput.toLowerCase()) {
            setHexInput(newHex)
        }
    }, [props.color])

    const sanitizeHex = (hex: string) => {
        let sanitized = hex.toLowerCase().replace(/[^0-9a-f]/g, "")

        if (sanitized.length < 6) {
            sanitized = sanitized.padEnd(6, "0")
        } else if (sanitized.length > 6) {
            sanitized = sanitized.slice(0, 6)
        }

        return sanitized
    }

    const handleHexChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let val = e.target.value

        if (!val.startsWith("#")) {
            val = "#" + val
        }

        setHexInput(val)
    }

    const handleHexBlur = () => {
        let hex = hexInput.startsWith("#") ? hexInput.slice(1) : hexInput

        hex = sanitizeHex(hex)

        const r = parseInt(hex.slice(0, 2), 16)
        const g = parseInt(hex.slice(2, 4), 16)
        const b = parseInt(hex.slice(4, 6), 16)

        if (props.setColor) {
            props.setColor({ r, g, b })
        }
        setHexInput("#" + hex)
    }

    return (
        <div className='palette-container-wrapper'>
            <div className="paletter-container-block">
                <h2>{t.palette}</h2>
                <div className="palette-container">
                    <SketchPicker
                        disableAlpha={true}
                        color={props.color}
                        onChange={handleChange}
                        onChangeComplete={handleChange}
                    />
                </div>
            </div>
            <div className="paletter-container-block">
                <h2>HEX</h2>
                <input
                    className="color-text-input"
                    type="text"
                    onChange={handleHexChange}
                    value={hexInput}
                    onBlur={handleHexBlur} />
            </div>
            <div className="paletter-container-block">
                <h2>RGB</h2>
                <div className="rgb-input-list palette-container">
                    <input className="color-text-input color-text-input-rgb" type="text" onChange={
                        (e) => {
                            if (props.setColor && props.color) {
                                props.setColor({
                                    r: getColorInput(e.target.value),
                                    g: props.color.g,
                                    b: props.color.b
                                })
                            }
                        }
                    } value={props.color?.r} />
                    <input className="color-text-input color-text-input-rgb" type="text" onChange={
                        (e) => {
                            if (props.setColor && props.color) {
                                props.setColor({
                                    r: props.color.r,
                                    g: getColorInput(e.target.value),
                                    b: props.color.b
                                })
                            }
                        }
                    } value={props.color?.g} />
                    <input className="color-text-input color-text-input-rgb" type="text" onChange={
                        (e) => {
                            if (props.setColor && props.color) {
                                props.setColor({
                                    r: props.color.r,
                                    g: props.color.g,
                                    b: getColorInput(e.target.value)
                                })
                            }
                        }
                    } value={props.color?.b} />
                </div>
            </div>
        </div>
    )
}